import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_FUEL_LOADING = 'GET_FUEL_LOADING';
export const GET_FUEL_SUCCESS = 'GET_FUEL_SUCCESS';
export const GET_FUEL_REJECT = 'GET_FUEL_REJECT';

//* ACTIONS ------------------------------------------------
export const getFuelLoading = () => ({ type: GET_FUEL_LOADING });
export const getFuelSuccess = (payload) => ({ type: GET_FUEL_SUCCESS, payload });
export const getFuelReject = (payload) => ({ type: GET_FUEL_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getFuelRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Fuels/web/GetAllFuels`, options);
};

